export default "__VITE_ASSET__269a8e26__"